<template>
  <el-dialog
    :visible="visible"
    @close="$emit('update:visible', false)"
    @closed="$refs.form.resetFields()"
    width="600px"
  >
    <div
      slot="title"
      class="Diatitle"
    >
      <span>{{isData == ''?'命令下发':isData == 'CKBMS:0'?'规格数据':'详细数据'}}</span>
    </div>
    <el-form
      :model="model"
      ref="form"
      :rules="rules"
      label-width="90px"
    >
      <el-row v-if="isData == ''">
        <el-col :span="22">
          <el-form-item
            label="指令:"
            prop="commandMsg"
          >
            <el-input
              type="textarea"
              size="small"
              v-model.trim="model.commandMsg"
              autocomplete="off"
              :disabled="isData != ''?true:false"
            />
          </el-form-item>
        </el-col>
      </el-row>
      

    </el-form>

    <template slot="footer" v-if="isData == ''">
      <el-button
        type="primary"
        plain
        size="small"
        @click="commandDown()"
      >确定</el-button>
      <el-button
        type="info"
        plain
        size="small"
        @click="$emit('update:visible', false)"
      >取消</el-button>

    </template>
  </el-dialog>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    params: {
      type: Object,
      default: undefined
    },
    isData:{
        type:String
    }
  },

  data() {
    return {
      model: {
        commandMsg: "",
        commandType: "DISPATCH",
        vehicleId: ""
      },
      rules: {
        commandMsg: [
          {
            required: true,
            message: "指令", //this.$t("login.username_rules"),
            trigger: "blur"
          }
        ]
      }
    };
  },
  watch:{

  },
  mounted(){
    
  },
  methods: {
    async commandDown() {
      try {
        await this.$refs.form.validate();
        this.model.vehicleId = this.params.vehicleId;
        const params = {
          ...this.model
        };
        const { msg } = await this.$API.commandDown(params);
        this.$msg({
          showClose: true,
          message: msg,
          type: "success"
        });
        this.$emit("update:visible", false);
      } catch (error) {
        this.$msg({
          showClose: true,
          message: error ? error.msg : "请输入正确字段",
          type: "error"
        });
      }
    },
    
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__body {
  padding: 30px 10px 0px 10px;
}
::v-deep .el-dialog__headerbtn {
  top: 12px !important;
}
.dataBtn{
      text-align: center;
      padding-bottom: 20px;
 }
.Diatitle {
  width: 100%;
  height: 42px;
  background-color: #f6f6f6;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  span {
    padding: 0 20px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
  }
}
</style>
